<template>
  <span>
      <a class="ck-logout-link" href="#" @click="logoutUser" title="Logout"><i class="fa fa-power-off"></i><span class="is-sr">Logout</span></a>
  </span>
</template>

<script>
export default {
    props: ['message', 'type'],
    data() {
        return {
            show: false
        }
    },
    methods: {
        logoutUser() {
          axios.post(`/logout`).then(res => {
          }).catch(e => {
            document.cookie = 'XSRF-TOKEN' + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            document.cookie = 'ck_sport_manager_session' + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';

            setTimeout(function() {
                window.location.replace(`${location.origin}/login`)
            }, 200)
          });
        }
    }

}
</script>

<style lang="scss">
    .ck-logout-link {
        color: white;
        font-size: 1.5rem;

        &:hover,
        &:focus {
            color: white;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/ckLogoutLink.vue